namespace RioERP.Orders {
    export namespace OrderProductsService {
        export const baseUrl = 'Orders/OrderProducts';

        export declare function Create(request: Serenity.SaveRequest<OrderProductsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<OrderProductsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<OrderProductsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetProductDetails(request: ExcelImportRequest, onSuccess?: (response: ExcelImportResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<OrderProductsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Orders/OrderProducts/Create",
            Update = "Orders/OrderProducts/Update",
            Delete = "Orders/OrderProducts/Delete",
            Retrieve = "Orders/OrderProducts/Retrieve",
            GetProductDetails = "Orders/OrderProducts/GetProductDetails",
            List = "Orders/OrderProducts/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'GetProductDetails', 
            'List'
        ].forEach(x => {
            (<any>OrderProductsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
